
import DeviceCard from "./DeviceCard";
import { type Device } from "@/hooks/useDevices";
import { getDeviceStatus } from "@/utils/deviceStatus";

interface DeviceGridProps {
  devices: Device[];
  searchQuery?: string;
}

const DeviceGrid = ({ devices, searchQuery = "" }: DeviceGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {devices.map((device) => (
        <DeviceCard
          key={device.id}
          searchQuery={searchQuery}
          device={{
            id: device.id,
            name: device.name,
            os: `${(device.platform || device.os_type || '').toString().toUpperCase()} ${device.os_version || ''}`.trim(),
            status: getDeviceStatus(device.last_seen || device.created_at, device.status),
            lastSeen: device.last_seen || device.created_at,
            ip: device.ip_address || 'N/A',
            installed_apps: Array.isArray(device.installed_apps) ? device.installed_apps : [],
            battery_level: device.battery_level,
            battery_status: device.battery_status,
            serial_number: device.serial_number,
            department: device.department || undefined,
            location: device.location || undefined,
            username: device.username,
            fullName: device.fullName ?? null,
            userEmail: device.userEmail,
          }}
        />
      ))}
    </div>
  );
};

export default DeviceGrid;
